export default __webpack_public_path__ + "static/media/hht2_ani_11.2be52e4c.png";